import { RevealBlock } from "./motion";
import { SlidersHorizontal, Users, Store, ShieldCheck } from "lucide-react";

const BENEFITS = [
  { icon: Users,              t: "Owner-operated service",      d: "MinisRus supplies, stocks and manages the machine from launch through day-to-day operation." },
  { icon: SlidersHorizontal,  t: "Location-ready model",       d: "The site operator approves the position, assortment and operating requirements." },
  { icon: Store,              t: "Space-efficient footprint",  d: "A compact, self-contained format for busy shared environments." },
  { icon: ShieldCheck,        t: "Managed operations",         d: "We handle replenishment, monitoring, servicing and customer support." },
];

export default function WhyPartner() {
  const smoothTo = (id) => document.querySelector(id)?.scrollIntoView({ behavior: 'smooth' });

  return (
    <section id="why" className="relative bg-cream text-ink py-16 md:py-24" data-testid="why-section">
      <div className="max-w-[1440px] mx-auto px-5 md:px-10 grid grid-cols-12 gap-8 md:gap-12 items-start">
        <div className="col-span-12 lg:col-span-5">
          <RevealBlock>
            <p className="eyebrow mb-3">What MinisRus Provides</p>
            <h2 className="font-display font-light text-ink text-3xl sm:text-4xl md:text-5xl leading-[1.05] tracking-tight">
              Fully owned.<br />
              <span className="text-orange">Fully managed.</span>
            </h2>
            <div className="mt-5 gold-rule" />
            <p className="mt-6 text-ink/70 text-base leading-relaxed max-w-md font-sans">
              MinisRus owns and operates the service end-to-end. The host location provides an approved site and access while we manage the machine, products, replenishment, monitoring and customer support.
            </p>
            <button
              onClick={() => smoothTo('#enquiries')}
              className="group mt-8 inline-flex items-center gap-2 h-12 px-7 bg-ink text-bone hover:bg-navy-soft rounded-full text-[13px] font-semibold transition-colors"
              data-testid="why-partner-btn"
            >
              Request a Site Assessment
              <span className="inline-block transition-transform group-hover:translate-x-1">→</span>
            </button>
          </RevealBlock>
        </div>

        <div className="col-span-12 lg:col-span-7 grid grid-cols-2 md:grid-cols-2 lg:grid-cols-2 gap-5 md:gap-6">
          {BENEFITS.map((b, i) => {
            const Icon = b.icon;
            return (
              <RevealBlock key={b.t} delay={i * 0.08} y={20} className="bg-white border border-ink/10 rounded-xl p-5 md:p-6 flex flex-col h-full card-lift shadow-[0_2px_10px_rgba(10,30,68,0.04)]">
                <div className="w-12 h-12 rounded-full bg-orange/15 flex items-center justify-center">
                  <Icon size={20} strokeWidth={1.7} className="text-orange-deep" />
                </div>
                <h3 className="mt-5 font-semibold text-ink text-base md:text-lg leading-tight">{b.t}</h3>
                <p className="mt-1.5 text-ink/60 text-sm leading-relaxed">{b.d}</p>
              </RevealBlock>
            );
          })}
        </div>
      </div>
    </section>
  );
}
